import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M23.5 3.5c11 0 20 9 20 20s-9 20-20 20-20-9-20-20 9-20 20-20m0-2.5C11.1 1 1 11.1 1 23.5S11.1 46 23.5 46 46 35.9 46 23.5 35.9 1 23.5 1z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M34.9 35.2H26v-8h-5v8h-8.9V11.8H21v7.4h5v-7.4h8.9v23.4zm-6.4-2.5h3.9V14.3h-3.9v7.4h-10v-7.4h-3.9v18.5h3.9v-8h10v7.9z"
	})]
});
export default SvgIcon;
